import React, { useState } from 'react';
import { Button, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import { CloseIcon, DateIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { classNames } from '../../../../../utils';

const styles = makeStyles((theme) => ({
  pop: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      width: '43.75rem',
      backgroundColor: theme.palette.font.white,
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
    },
  },
  poproot: {
    padding: '2.375rem 1.563rem 1.875rem',
    width: '43.75rem',
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2.125rem',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: 'bold',
  },
  icon: {
    fontSize: '1.375rem',
    color: theme.palette.primary.main,
  },
  context: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  datepicker: {
    width: '100%',
    '& .MuiInputBase-root': {
      padding: '0 1rem 0 1.25rem',
      borderRadius: '0.625rem',
      border: '0.0625rem solid #e4e7eb',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
    },
    '& .MuiPaper-root': {
      borderRadius: '0.9375rem',
    },
  },
  Picon: {
    width: '1.125rem',
    height: '1.25rem',
    color: theme.palette.primary.main,
  },
  foot: {
    marginTop: '3.25rem',
    display: 'flex',
    justifyContent: 'center',
  },
  cancel: {
    textTransform: 'capitalize',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    backgroundColor: '#eff6ff',
    color: theme.palette.primary.main,
    fontWeight: '500',
    borderRadius: '0.625rem',
    border: '0.12rem solid #538fff',
    width: '12.5rem',
    height: '3rem',
    marginRight: '1.25rem',
  },
  confirm: {
    textTransform: 'capitalize',
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
  labelError: {
    color: '#f44336',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

export default function PostDayPop({ open, closePop, errorMsg, error, verify, sendClick }) {
  const classes = styles();

  const [date, setDate] = useState(moment().add(1, 'h').format('yyyy-MM-DD HH:00:00'));
  const changeHandle = (event) => {
    setDate(event);
    verify(event);
  };

  const getIsSave = () => {
    return moment(date).isValid() && !errorMsg;
  };

  const getIsError = () => {
    return moment(date).isValid() ? Boolean(errorMsg) : false;
  };

  const handleSend = async () => {
    try {
      if (getIsSave()) {
        await sendClick({ postDate: date, callback: closePop });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog className={classes.pop} open={open} id="Notification-Dialog-abb">
      <div className={classes.poproot}>
        <div className={classes.head}>
          <div className={classes.title}>{i18n.t('EHANDOVER_CREATENOTE_POST')}</div>
          <IconButton onClick={closePop} id="Notification-IconButton-abc">
            <CloseIcon className={classes.icon} />
          </IconButton>
        </div>
        <div>
          <div className={getIsError() ? classNames(classes.context, classes.labelError) : classes.context}>
            {i18n.t('EHANDOVER_CREATENOTE_POST_TITLE')}
          </div>
          <KeyboardDateTimePicker
            autoOk
            className={classes.datepicker}
            onChange={changeHandle}
            id="Notification-KeyboardDateTimePicker-abd"
            keyboardIcon={<DateIcon className={classes.Picon} id="123123123" />}
            value={date}
            variant="inline"
            format="yyyy-MM-DD HH:00:00"
            inputVariant="outlined"
            InputAdornmentProps={{ position: 'end' }}
            placeholder="Start Date"
            // minDate={moment().format('yyyy-MM-DD HH:00:00')}
            views={['date', 'hours']}
            disablePast={!getIsError()}
            disableToolbar={true}
            ampm={false}
            error={error}
            minDateMessage=""
          />
          {getIsError() ? <Typography className={classes.errorMsg}>{errorMsg}</Typography> : ''}
        </div>
        <div className={classes.foot}>
          <Button className={classes.cancel} onClick={closePop} id="Notification-Button-abe">
            {i18n.t('EHANDOVER_CREATENOTE_POST_CANCEL')}
          </Button>
          <Button
            className={classes.confirm}
            onClick={() => {
              (async () => {
                await handleSend();
              })();
            }}
            id="Notification-Button-abf"
          >
            {i18n.t('EHANDOVER_CREATENOTE_POST_SAVE')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
